export const DEFAULT_META = [];

export const EXCLUDE_KEYS = ['title_tag', 'description_tag'];

export const getTextFromRichText = (richText) => {
  if (richText.type === 'text') return richText.value;
  if (richText.children && Array.isArray(richText.children)) {
    return richText.children.map((child) => getTextFromRichText(child)).join(' ');
  }
  return '';
};

export const UNITS_DIMENSION = {
  METERS: 'm',
  CENTIMETERS: 'cm',
  MILLIMETERS: 'mm',
  FEET: 'ft',
  INCHES: 'in',
  YARDS: 'yd',
};

export const UNITS_WEIGHT = {
  OUNCES: 'oz',
  POUNDS: 'lb',
  GRAMS: 'g',
  KILOGRAMS: 'kg',
};

export const UNITS_VOLUME = {
  MILLILITERS: 'ml',
  CENTILITERS: 'cl',
  LITERS: 'L',
  CUBIC_METERS: 'm³',
  FLUID_OUNCES: 'fl oz',
  PINTS: 'pt',
  QUARTS: 'qt',
  GALLONS: 'gal',
  IMPERIAL_FLUID_OUNCES: 'imp fl oz',
  IMPERIAL_PINTS: 'imp pt',
  IMPERIAL_QUARTS: 'imp qt',
  IMPERIAL_GALLONS: 'imp gal',
};
